import HowToRegIcon from '@mui/icons-material/HowToReg';

const icons = {
  HowToRegIcon
};

const preapproval = {
  id: 'preapproval',
  type: 'group',
  children: [
    {
      id: 'preapproval',
      title: 'Re-Sent Claim Link',
      type: 'item',
      url: '/Registration-Approval',
      icon: icons.HowToRegIcon,
    }
  ]
};

export default preapproval;
